import gql from 'graphql-tag';

import { CourseS12nInfoV2Fragment } from 'bundles/video-logged-out-page/components/course-content/CourseS12nInfo';

export const CourseDetailsQueryVlp = gql`
  query CourseDetailsQueryVlp($courseSlug: String!) {
    XdpV1Resource {
      slug(productType: "COURSE", slug: $courseSlug) {
        elements {
          id
          xdpMetadata {
            __typename
            ... on XdpV1_cdpMetadataMember {
              cdpMetadata {
                id
                name
                slug
                premiumExperienceVariant
                description
                primaryLanguages
                photoUrl
                skills
                totalEnrollmentCount
                primaryS12n {
                  ...CourseS12nInfoV2Fragment
                }
                ratings {
                  averageFiveStarRating
                  ratingCount
                }
                instructors {
                  department
                  shortName
                  firstName
                  fullName
                  id
                  lastName
                  photo
                  title
                }
                partners {
                  id
                  shortName
                  name
                  squareLogo
                }
                domains {
                  domainId
                  domainName
                  subdomainId
                  subdomainName
                }
                topReviews {
                  comment
                  authorName
                  averageFiveStarRating
                  timestamp
                  reviewId
                }
              }
            }
          }
        }
      }
    }
    OnDemandCoursesV1Resource {
      slug(slug: $courseSlug) {
        elements {
          id
          launchedAt
          overridePartnerLogos
        }
      }
    }
  }
  ${CourseS12nInfoV2Fragment}
`;
